import { Typography } from "@mui/material" // Import Grid from MUI
import Grid from "@mui/material/Grid2"
import moment from "moment"
import React from "react"
import { Calendar, momentLocalizer } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "./index.css"
import CustomToolbar from "./CustomToolbar"
import { CANCELLED } from "../../utils/constants"
import { DayEvent } from "./Events"
const localizer = momentLocalizer(moment)

function CalendarComponents(props) {
  const {
    groupArrays,
    onClickMore,
    view,
    mergedEvents,
    allEvents,
    currentDate,
    handleDateSelect,
    onSelectEvent,
    selectedDate,
    handleNavigate,
    handleView,
    handleToday,
  } = props

  const WeekEvent = (event) => {
    if (event?.event?.allDay) {
      return (
        <Typography>
          {event?.event?.status === CANCELLED ? <del style={{ color: "red" }}>{event?.title}</del> : event?.title}
        </Typography>
      )
    }
    const startDate = new Date(event?.event?.start)
    const date = `${startDate?.getDate()}-${startDate?.getMonth()}-${startDate?.getFullYear()}`
    const eventsUnderThisDate = groupArrays?.find((each) => each?.date === date)
    const eventsLength = eventsUnderThisDate.events.length
    const formatedDate = moment(startDate).format("DD-MM-YYYY")
    // if (eventsLength <= 1) return
    return <div>
      <Typography>
        {event?.event?.status === CANCELLED ? <del style={{ color: "red" }}>{event?.title}</del> : event?.title}
      </Typography>
    </div>

    /*
    return (
      <div style={{ marginLeft: "auto", display: "flex", justifyContent: "center" }}>
        <button
          style={{
            // backgroundColor: "orange",
            color: "#1E1E1E",
            border: "none",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
          }}
          onClick={() => {
            onClickMore(eventsUnderThisDate.events)
            // handleOpenModal();
            // setModalEvents(
            //     eventsUnderThisDate?.events?.filter((each) => !each.allDay)
            // );
            // onChangeDate1(formatedDate);
          }}
        >
          +{eventsLength - 1} more
        </button>
      </div>
    )
    */
  }



  const renderToolbar = (toolbarProps) => (
    <CustomToolbar
      {...toolbarProps}
      currentView={view}
      handleView={handleView}
      onNavigate={handleNavigate}
      onToday={handleToday}
    />
  )

  return (
    <Grid item xs={12} md={9} className="calendar-main-container">
      <Calendar
        views={["month", "week", "day"]}
        localizer={localizer}
        events={(view === "month") ? mergedEvents : allEvents}
        // events={view === "week" ? flattenedEvents : allEvents}
        // className={view === "week" && "week-view"}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 550 }}
        eventPropGetter={(event) => {
          const backgroundColor = event.allDay
            ? "yellow"
            : (event?.doctorColor ?? "#1565c0")
          return { style: { backgroundColor } }
        }}
        // allDayMaxRows={3}
        components={{
          toolbar: renderToolbar,
          week: {
            event: WeekEvent,
          },
          day: {
            event: DayEvent,
          },
        }}
        date={currentDate}
        onSelectSlot={handleDateSelect}
        selectable={true}
        onSelectEvent={onSelectEvent}
        dayPropGetter={(date) => {
          const isSelected =
            selectedDate && date.toDateString() === selectedDate.toDateString()
          return {
            style: {
              backgroundColor: isSelected ? "#eaf6ff" : "",
              color: isSelected ? "white" : "",
            },
          }
        }}
        view={view}
        showAllEvents
        eventContent={(event) => (
          <div style={{ padding: "5px", fontSize: "12px" }}>
            <strong style={{ fontSize: "14px" }}>{event.doctorName}</strong>
            <br />
            <span>{event.title}</span>
          </div>
        )}
      />
    </Grid>
  )
}

export default CalendarComponents
